const dev = {
  mediaforta: {
    AUTH_URL: 'http://localhost:5000/auth/',
    USER_URL: 'http://localhost:5000/users/',
    API_URL: 'http://localhost:5000/api/v1/',
    JOBS_URL: 'http://mediaforta.com/jobs',
    // Cloudflare Turnstile. Empty = no widget rendered, no error shown.
    CAPTCHA_SITE_KEY: ''
  }
}

const prod = {
  mediaforta: {
    AUTH_URL: 'https://jobs-api.mediaforta.com/auth/',
    USER_URL: 'https://jobs-api.mediaforta.com/users/',
    API_URL: 'https://jobs-api.mediaforta.com/api/v1/',
    JOBS_URL: 'http://mediaforta.com/jobs',
    // Cloudflare Turnstile. Get a key at dash.cloudflare.com -> Turnstile,
    // with jobs.mediaforta.com as the allowed hostname. Empty until then:
    // the widget is simply not rendered, as it is not verified server-side
    // anyway. Replaced Google reCAPTCHA, whose key returned
    // "ERROR for site owner: Invalid site key" on 2026-09-27.
    CAPTCHA_SITE_KEY: ''
  }
}

const config = process.env.REACT_APP_STAGE === 'production'
  ? prod
  : dev

export default config